import { useState, useEffect } from 'react'
import { supabase, funzioneUrl } from '../lib/supabase'
import ModaleConferma from './ModaleConferma'
import { useAuth } from '../lib/AuthContext'
import CreaSessione from './CreaSessione'
import ReportAtleta from './ReportAtleta'
import TopBar from './TopBar'
import { useIndietro } from '../lib/navigazioneIndietro'
import { nomeFormato, ICONA_FORMATO } from '../lib/formati'

/** Oggi in formato YYYY-MM-DD: il minimo accettabile per programmare qualcosa. */
function oggiISO() { return new Date().toISOString().split('T')[0] }

export default function GestioneGruppi({ tabIniziale = 'creati', onCambiaTab, coachPremium, onRichiediUpgrade }) {
  const { profilo } = useAuth()
  const [vistaTab, setVistaTab] = useState(tabIniziale) // 'creati' | 'iscritto'
  const [gruppi, setGruppi] = useState([])
  const [gruppoSel, setGruppoSel] = useState(null)
  const [membri, setMembri] = useState([])
  const [sessioni, setSessioni] = useState([])
  const [calendario, setCalendario] = useState([])
  const [tab, setTab] = useState('membri')
  const [creaGruppo, setCreaGruppo] = useState(false)
  const [creaSessione, setCreaSessione] = useState(false)
  const [modificaSessione, setModificaSessione] = useState(null)
  const [reportAtleta, setReportAtleta] = useState(null)
  const [mostraAggiungi, setMostraAggiungi] = useState(false)
  const [richieste, setRichieste] = useState([])   // chi è entrato col link e attende approvazione
  const [invito, setInvito] = useState(null)       // link d'invito attivo del gruppo
  const [creandoInvito, setCreandoInvito] = useState(false)
  const [assegnaSessione_id, setAssegnaSessione_id] = useState(null)
  const [assegnaData, setAssegnaData] = useState(oggiISO())
  const [modificaCalId, setModificaCalId] = useState(null)
  const [modificaCalData, setModificaCalData] = useState('')
  const [confermaRimuovi, setConfermaRimuovi] = useState(null)
  const [emailInvito, setEmailInvito] = useState('')
  const [nomeGruppo, setNomeGruppo] = useState('')
  const [descGruppo, setDescGruppo] = useState('')
  const [toast, setToast] = useState('')
  const [caricamento, setCaricamento] = useState(true)
  const [rinominaMode, setRinominaMode] = useState(false)
  const [rinominaNome, setRinominaNome] = useState('')
  const [confermaEliminaSessione, setConfermaEliminaSessione] = useState(null)
  const [membriPending, setMembriPending] = useState([])
  const [invitoNonIscritto, setInvitoNonIscritto] = useState(false)
  const [linkInvito, setLinkInvito] = useState(null)
  const [emailInvitoStato, setEmailInvitoStato] = useState(null) // null | 'invio' | 'ok' | 'errore'
  const [gruppiMembro, setGruppiMembro] = useState([]) // gruppi altrui in cui il coach è membro
  const [confermaEsciGruppo, setConfermaEsciGruppo] = useState(null)
  const [confermaEliminaGruppo, setConfermaEliminaGruppo] = useState(null)
  const [calendarioPassate, setCalendarioPassate] = useState([])
  const [sessioniArchiviate, setSessioniArchiviate] = useState([])
  const [mostraArchiviate, setMostraArchiviate] = useState(false)
  const [vistaCalendario, setVistaCalendario] = useState('prossime') // 'prossime' | 'passate'
  const [gruppiArchiviati, setGruppiArchiviati] = useState([])
  const [statsGruppi, setStatsGruppi] = useState({}) // {gruppoId: {membri, pending, sessioni, prossima}} — stato setup mostrato sulla card
  const [menuGruppo, setMenuGruppo] = useState(null)  // id del gruppo con il menu "⋯" aperto
  const [mostraArchiviati, setMostraArchiviati] = useState(false)
  const [conferma, setConferma] = useState(null) // { titolo, testo, testoConferma, distruttiva, onConferma }
  // Messaggio al gruppo: era un window.prompt, l'ultimo rimasto nell'app.
  // Su iPhone con l'app installata (standalone) il prompt del browser può non
  // comparire affatto, e il coach premeva 💬 senza che accadesse nulla.
  const [mostraMessaggio, setMostraMessaggio] = useState(false)
  const [testoMessaggio, setTestoMessaggio] = useState('')
  const [inviandoMessaggio, setInviandoMessaggio] = useState(false)

  useEffect(() => { caricaGruppi() }, [])

  // Tasto indietro: stesse chiusure delle frecce dell'app (report → gruppo → elenco)
  useIndietro(!!gruppoSel, () => { setGruppoSel(null); setRinominaMode(false) })
  useIndietro(creaSessione, () => setCreaSessione(false))
  useIndietro(!!modificaSessione, () => setModificaSessione(null))
  useIndietro(!!reportAtleta, () => setReportAtleta(null))
  useIndietro(mostraMessaggio, () => setMostraMessaggio(false))

  // Apertura diretta di un gruppo richiesta da un'altra schermata (es. una sessione
  // cliccata nella home del coach): evita di far ripartire la navigazione da capo.
  useEffect(() => {
    const richiesta = sessionStorage.getItem('fp_apri_gruppo')
    if (!richiesta) return
    sessionStorage.removeItem('fp_apri_gruppo')
    try {
      const { id, nome, tab: tabRichiesto } = JSON.parse(richiesta)
      if (!id) return
      if (tabRichiesto) setTab(tabRichiesto)
      setGruppoSel({ id, nome })
    } catch {}
  }, [])

  useEffect(() => { if (gruppoSel) { caricaMembri(); caricaSessioni(); caricaCalendario() } }, [gruppoSel])

  async function caricaGruppi() {
    const [{ data: creati }, { data: membroDi }] = await Promise.all([
      supabase.from('gruppi').select('*').eq('gestore_id', profilo.id).eq('attivo', true).order('creato_il', { ascending: false }),
      supabase.from('gruppo_membri')
        .select('gruppo_id, gruppi(*, profili!gruppi_gestore_id_fkey(nome, cognome))')
        .eq('utente_id', profilo.id)
        .eq('stato', 'attivo'),
    ])
    setGruppi(creati || [])
    // Statistiche per gruppo: servono a mostrare sulla card se il setup è completo
    // (un gruppo senza atleti o senza sessioni programmate non è ancora utile a nessuno)
    if (creati?.length) {
      const ids = creati.map(g => g.id)
      const oggiStr = oggiISO()
      const [{ data: tuttiMembri }, { data: tutteSessioni }, { data: tuttoCalendario }] = await Promise.all([
        supabase.from('gruppo_membri').select('gruppo_id, stato').in('gruppo_id', ids),
        supabase.from('sessioni_tipo').select('gruppo_id').in('gruppo_id', ids).eq('archiviata', false),
        supabase.from('sessioni_calendario').select('gruppo_id, data').in('gruppo_id', ids).eq('archiviata', false).gte('data', oggiStr).order('data', { ascending: true }),
      ])
      const stats = {}
      ids.forEach(id => { stats[id] = { membri: 0, pending: 0, sessioni: 0, prossima: null } })
      ;(tuttiMembri || []).forEach(m => {
        if (!stats[m.gruppo_id]) return
        if (m.stato === 'attivo') stats[m.gruppo_id].membri++
        else if (m.stato === 'pending') stats[m.gruppo_id].pending++
      })
      ;(tutteSessioni || []).forEach(s => { if (stats[s.gruppo_id]) stats[s.gruppo_id].sessioni++ })
      ;(tuttoCalendario || []).forEach(c => {
        if (stats[c.gruppo_id] && !stats[c.gruppo_id].prossima) stats[c.gruppo_id].prossima = c.data
      })
      setStatsGruppi(stats)
    } else {
      setStatsGruppi({})
    }
    // Filtra i gruppi altrui (non creati da questo coach)
    const miei_ids = new Set((creati || []).map(g => g.id))
    const altri = (membroDi || [])
      .map(m => m.gruppi)
      .filter(g => g && !miei_ids.has(g.id))
    setGruppiMembro(altri)
    // Carica gruppi archiviati
    const { data: archiviati } = await supabase.from('gruppi').select('*').eq('gestore_id', profilo.id).eq('attivo', false).order('creato_il', { ascending: false })
    setGruppiArchiviati(archiviati || [])
    setCaricamento(false)
  }

  async function caricaMembri() {
    // Scade automaticamente gli inviti pending oltre 7 giorni.
    // Il nome arriva dalla stessa query: prima veniva cercato in membriPending,
    // che al primo caricamento è ancora vuoto, e la notifica al coach diceva
    // sempre "Un atleta non ha risposto" anche quando il nome si sapeva.
    const settimanaFa = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
    const { data: scaduti } = await supabase
      .from('gruppo_membri')
      .select('id, utente_id, profili(nome)')
      .eq('gruppo_id', gruppoSel.id)
      .eq('stato', 'pending')
      .lt('creato_il', settimanaFa)
    if (scaduti?.length) {
      await supabase.from('gruppo_membri')
        .update({ stato: 'scaduto' })
        .in('id', scaduti.map(s => s.id))
      // Notifica al coach per ogni invito scaduto
      const avvisi = scaduti.map(s => ({
        utente_id: profilo.id,
        tipo: 'info',
        titolo: 'Invito scaduto',
        testo: `${s.profili?.nome || 'Un atleta'} non ha risposto all'invito per il gruppo "${gruppoSel.nome}" entro 7 giorni.`,
      }))
      await supabase.from('notifiche').insert(avvisi)
    }
    const [{ data: attivi }, { data: pending }, { data: richiesteDati }, { data: invitoDati }] = await Promise.all([
      supabase.from('gruppo_membri')
        .select('*, profili(nome, cognome, email, piano)')
        .eq('gruppo_id', gruppoSel.id)
        .eq('stato', 'attivo'),
      supabase.from('gruppo_membri')
        .select('*, profili(nome, cognome, email, piano)')
        .eq('gruppo_id', gruppoSel.id)
        .eq('stato', 'pending'),
      supabase.from('gruppo_membri')
        .select('*, profili(nome, cognome, email, piano)')
        .eq('gruppo_id', gruppoSel.id)
        .eq('stato', 'richiesta'),
      supabase.from('inviti_gruppo')
        .select('*').eq('gruppo_id', gruppoSel.id).eq('revocato', false)
        .gt('scadenza', new Date().toISOString())
        .order('creato_il', { ascending: false }).limit(1),
    ])
    setMembri(attivi || [])
    setMembriPending(pending || [])
    setRichieste(richiesteDati || [])
    setInvito((invitoDati || [])[0] || null)
  }

  /** Solo chi è davvero nel gruppo riceve le notifiche.
   *
   *  Prima le notifiche andavano a TUTTE le righe di gruppo_membri, senza
   *  guardare lo stato: un atleta rimosso dal gruppo, o che aveva rifiutato
   *  l'invito, continuava a ricevere "Il coach ha programmato una sessione".
   */
  async function membriAttiviIds() {
    const { data } = await supabase.from('gruppo_membri')
      .select('utente_id').eq('gruppo_id', gruppoSel.id).eq('stato', 'attivo')
    return (data || []).map(m => m.utente_id).filter(Boolean)
  }

  // ── LINK D'INVITO ──
  // Prima l'unico modo di aggiungere un atleta era digitarne l'email, una alla volta.
  // Il link si condivide una volta sola e vale per tutti; a proteggere il gruppo è
  // l'approvazione del coach, non la segretezza del link.
  // crypto.randomUUID non esiste su tutti i browser (e richiede connessione sicura):
  // senza alternativa, su quei dispositivi la creazione del link fallirebbe in silenzio
  function generaToken() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, '')
    if (window.crypto?.getRandomValues) {
      const b = new Uint8Array(16); window.crypto.getRandomValues(b)
      return [...b].map(x => x.toString(16).padStart(2, '0')).join('')
    }
    return (Date.now().toString(16) + Math.random().toString(16).slice(2)).padEnd(32, '0').slice(0, 32)
  }

  async function creaInvito() {
    setCreandoInvito(true)
    const scadenza = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)   // 30 giorni
    const { data, error } = await supabase.from('inviti_gruppo').insert({
      gruppo_id: gruppoSel.id, token: generaToken(),
      creato_da: profilo.id, scadenza: scadenza.toISOString(),
    }).select().single()
    setCreandoInvito(false)
    if (error) { toast_msg('Errore: ' + error.message); return }
    setInvito(data)
  }

  function urlInvito(inv) { return `https://fitprogress.it/?invito=${inv.token}` }

  async function copiaLink() {
    try {
      await navigator.clipboard.writeText(urlInvito(invito))
      toast_msg('Link copiato')
    } catch { toast_msg('Copia non riuscita, seleziona il link a mano') }
  }

  async function revocaInvito() {
    await supabase.from('inviti_gruppo').update({ revocato: true }).eq('id', invito.id)
    setInvito(null)
    toast_msg('Link revocato · creane uno nuovo quando vuoi')
  }

  async function rispondiRichiesta(membroId, nome, approva) {
    const { error } = await supabase.from('gruppo_membri')
      .update({ stato: approva ? 'attivo' : 'rifiutato' }).eq('id', membroId)
    if (error) {
      // Il limite del piano Free ora scatta anche qui: approvare una richiesta è
      // una UPDATE, e il trigger a database copriva solo le INSERT — un coach
      // Free con 3 atleti poteva accettarne un quarto dal link d'invito.
      if (error.message?.includes('LIMITE_PIANO_FREE_MEMBRI')) {
        toast_msg('⚡ Il piano Free include fino a 3 atleti per gruppo. Passa a Premium per accettarlo.')
        if (onRichiediUpgrade) onRichiediUpgrade()
        return
      }
      toast_msg('Errore: ' + error.message); return
    }
    const m = richieste.find(r => r.id === membroId)
    if (m?.utente_id) {
      await supabase.from('notifiche').insert({
        utente_id: m.utente_id, tipo: 'risposta_richiesta',
        titolo: approva ? 'Richiesta accettata' : 'Richiesta non accettata',
        testo: approva ? `Sei entrato nel gruppo "${gruppoSel.nome}"` : `La tua richiesta per "${gruppoSel.nome}" non è stata accettata`,
        letta: false,
      })
    }
    toast_msg(approva ? `${nome || 'Atleta'} è nel gruppo` : 'Richiesta rifiutata')
    caricaMembri(); caricaGruppi()
  }

  async function caricaSessioni() {
    const [{ data }, { data: arch }] = await Promise.all([
      supabase.from('sessioni_tipo').select('*').eq('gruppo_id', gruppoSel.id).eq('archiviata', false).order('creato_il', { ascending: false }),
      supabase.from('sessioni_tipo').select('*').eq('gruppo_id', gruppoSel.id).eq('archiviata', true).order('creato_il', { ascending: false }),
    ])
    setSessioni(data || [])
    setSessioniArchiviate(arch || [])
  }

  // Ripristino: rimette in lista la sessione e le sue date. Senza questo
  // l'archiviazione sarebbe irreversibile per chi usa l'app.
  async function ripristinaSessione(sessioneId) {
    await supabase.from('sessioni_tipo').update({ archiviata: false }).eq('id', sessioneId)
    await supabase.from('sessioni_calendario').update({ archiviata: false }).eq('sessione_tipo_id', sessioneId)
    caricaSessioni(); caricaCalendario()
    toast_msg('Sessione ripristinata')
  }

  async function caricaCalendario() {
    const oggi = oggiISO()
    const [{ data: future }, { data: passate }] = await Promise.all([
      supabase.from('sessioni_calendario').select('*, sessioni_tipo(nome)').eq('gruppo_id', gruppoSel.id).eq('archiviata', false).gte('data', oggi).order('data').limit(20),
      supabase.from('sessioni_calendario').select('*, sessioni_tipo(nome)').eq('gruppo_id', gruppoSel.id).eq('archiviata', false).lt('data', oggi).order('data', { ascending: false }).limit(20),
    ])
    setCalendario(future || [])
    setCalendarioPassate(passate || [])
  }

  async function creaNuovoGruppo() {
    if (!nomeGruppo.trim()) { toast_msg('Inserisci il nome del gruppo'); return }
    // Piano Free: 1 solo gruppo. Il database blocca comunque l'inserimento anche se
    // questo controllo venisse aggirato, ma qui diamo un messaggio chiaro invece di un errore secco.
    if (!coachPremium && gruppi.length >= 1) {
      toast_msg('⚡ Il piano Free include 1 gruppo. Passa a Premium per crearne altri.')
      setCreaGruppo(false)
      if (onRichiediUpgrade) onRichiediUpgrade()
      return
    }
    const { data, error } = await supabase.from('gruppi').insert({ nome: nomeGruppo, descrizione: descGruppo, gestore_id: profilo.id }).select().single()
    if (error) {
      // Il limite è imposto anche da un trigger a DB: intercetto l'eccezione per mostrare
      // un messaggio comprensibile (e un invito all'upgrade) invece dell'errore tecnico.
      if (error.message?.includes('LIMITE_PIANO_FREE_GRUPPI')) {
        toast_msg('⚡ Il piano Free include 1 gruppo. Passa a Premium per crearne altri.')
        setCreaGruppo(false)
        if (onRichiediUpgrade) onRichiediUpgrade()
        return
      }
      toast_msg('Errore: ' + error.message); return
    }
    toast_msg('✅ Gruppo creato!')
    setNomeGruppo(''); setDescGruppo(''); setCreaGruppo(false)
    caricaGruppi()
    setGruppoSel(data)
  }

  async function eliminaGruppo(gruppo) {
    // Un gruppo con allenamenti già svolti non si elimina: cancellarlo porterebbe via
    // lo storico degli atleti. Si propone invece l'archiviazione, che esiste già.
    const { data: date, error: errDate } = await supabase.from('sessioni_calendario').select('id').eq('gruppo_id', gruppo.id)
    if (errDate) { toast_msg('Impossibile verificare il gruppo, riprova'); return }
    const conRisultati = await calendariConRisultati((date || []).map(d => d.id))
    if (!conRisultati) { toast_msg('Impossibile verificare il gruppo, riprova'); return }
    if (conRisultati.size > 0) {
      setConfermaEliminaGruppo(null)
      // Se il gruppo è GIÀ archiviato, proporre di archiviarlo è un giro a vuoto:
      // il coach premeva "Elimina per sempre" e si ritrovava il pulsante
      // "Archivia gruppo", che non cambiava nulla e non spiegava niente.
      if (gruppo.attivo === false) {
        setConferma({
          titolo: 'Questo gruppo non si può eliminare',
          testo: `"${gruppo.nome}" contiene allenamenti già svolti dai tuoi atleti. Eliminarlo porterebbe via il loro storico e i loro progressi, che sono dati loro e non tuoi. Resta archiviato: non compare tra i tuoi gruppi attivi e non conta per i limiti del piano.`,
          testoConferma: 'Ho capito', icona: '🔒',
          onConferma: () => setConferma(null),
        })
        return
      }
      setConferma({
        titolo: 'Il gruppo contiene allenamenti svolti',
        testo: `Eliminare "${gruppo.nome}" cancellerebbe lo storico degli atleti. Puoi archiviarlo: sparisce dalla tua lista e i risultati degli atleti restano al sicuro. Potrai ripristinarlo quando vuoi.`,
        testoConferma: 'Archivia gruppo', icona: '📦',
        onConferma: () => { setConferma(null); archiviaGruppo(gruppo) },
      })
      return
    }
    // Nessun allenamento svolto: eliminazione completa.
    // Ogni passo va controllato: prima nessuno lo era, e se una delete falliva
    // (un vincolo, un permesso) il coach leggeva "Gruppo eliminato" e poi si
    // ritrovava il gruppo ancora in lista al caricamento successivo.
    for (const tabella of ['sessioni_calendario', 'sessioni_tipo', 'gruppo_membri']) {
      const { error } = await supabase.from(tabella).delete().eq('gruppo_id', gruppo.id)
      if (error) { toast_msg(`Eliminazione non riuscita (${tabella}): ${error.message}`); return }
    }
    const { error: errGruppo } = await supabase.from('gruppi').delete().eq('id', gruppo.id)
    if (errGruppo) { toast_msg('Eliminazione non riuscita: ' + errGruppo.message); return }
    setConfermaEliminaGruppo(null)
    toast_msg('Gruppo eliminato')
    caricaGruppi()
  }

  async function archiviaGruppo(gruppo) {
    const { error } = await supabase.from('gruppi').update({ attivo: false }).eq('id', gruppo.id)
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('📦 Gruppo archiviato')
    caricaGruppi()
  }

  async function ripristinaGruppo(gruppo) {
    const { error } = await supabase.from('gruppi').update({ attivo: true }).eq('id', gruppo.id)
    if (error) {
      // Ripristinare è una UPDATE: il limite di 1 gruppo del piano Free vale
      // anche qui, altrimenti si aggirava archiviando e ripristinando.
      if (error.message?.includes('LIMITE_PIANO_FREE_GRUPPI')) {
        toast_msg('⚡ Il piano Free include 1 gruppo attivo. Archivia quello attuale o passa a Premium.')
        if (onRichiediUpgrade) onRichiediUpgrade()
        return
      }
      toast_msg('Errore: ' + error.message); return
    }
    toast_msg('✅ Gruppo ripristinato')
    caricaGruppi()
  }

  async function esciDaGruppo(gruppo) {
    await supabase.from('gruppo_membri')
      .update({ stato: 'rimosso' })
      .eq('gruppo_id', gruppo.id)
      .eq('utente_id', profilo.id)
    setConfermaEsciGruppo(null)
    toast_msg('Sei uscito dal gruppo')
    caricaGruppi()
  }

  async function invitaMembro() {
    if (!emailInvito.trim()) return
    // Piano Free: max 3 atleti per gruppo (pending + attivi). Il database blocca comunque
    // l'inserimento anche se questo controllo venisse aggirato (es. via link diretto).
    if (!coachPremium && (membri.length + membriPending.length) >= 3) {
      toast_msg('⚡ Il piano Free include fino a 3 atleti per gruppo. Passa a Premium per aggiungerne altri.')
      setMostraAggiungi(false)
      if (onRichiediUpgrade) onRichiediUpgrade()
      return
    }
    const email = emailInvito.trim().toLowerCase()
    const { data: utente } = await supabase
      .from('profili').select('id,nome,cognome').eq('email', email).maybeSingle()

    if (utente) {
      // ── Utente iscritto: invito via notifica in-app ──
      // Controlla se già membro o già invitato
      const { data: esistente } = await supabase.from('gruppo_membri')
        .select('id, stato').eq('gruppo_id', gruppoSel.id).eq('utente_id', utente.id).maybeSingle()
      if (esistente?.stato === 'attivo') { toast_msg('⚠️ Già membro del gruppo'); return }
      if (esistente?.stato === 'pending') { toast_msg('⚠️ Invito già inviato, in attesa di risposta'); return }

      // Chi è già stato nel gruppo (rimosso, rifiutato, scaduto, annullato) ha
      // ancora la sua riga, e gruppo_membri ha un vincolo di unicità su
      // (gruppo_id, utente_id): una nuova insert veniva rifiutata dal database e
      // al coach compariva l'errore tecnico di Postgres invece dell'invito.
      // Si riusa la riga esistente, azzerando creato_il — da cui dipende la
      // scadenza a 7 giorni, che altrimenti sarebbe già passata.
      const esito = esistente
        ? await supabase.from('gruppo_membri')
            .update({ stato: 'pending', creato_il: new Date().toISOString() })
            .eq('id', esistente.id)
        : await supabase.from('gruppo_membri').insert({
            gruppo_id: gruppoSel.id,
            utente_id: utente.id,
            stato: 'pending',
          })
      if (esito.error) {
        if (esito.error.message?.includes('LIMITE_PIANO_FREE_MEMBRI')) {
          toast_msg('⚡ Il piano Free include fino a 3 atleti per gruppo. Passa a Premium per aggiungerne altri.')
          if (onRichiediUpgrade) onRichiediUpgrade()
          return
        }
        toast_msg('Errore: ' + esito.error.message); return
      }

      // Notifica in-app all'atleta
      await supabase.from('notifiche').insert({
        utente_id: utente.id,
        tipo: 'invito_gruppo',
        titolo: '👥 Invito gruppo',
        testo: `Il coach ${profilo.nome} ${profilo.cognome || ''} ti ha invitato nel gruppo "${gruppoSel.nome}". Accetta o rifiuta dall'app.`,
        dati: JSON.stringify({ gruppo_id: gruppoSel.id, gruppo_nome: gruppoSel.nome, coach_id: profilo.id }),
      })
      toast_msg(`✅ Invito inviato a ${utente.nome}!`)
      setEmailInvito(''); setMostraAggiungi(false)
      caricaMembri()
    } else {
      // ── Utente non iscritto: il coach sceglie come inviare il link di registrazione ──
      const link = `https://fitprogress.it/?invito_gruppo=${gruppoSel.id}&coach=${profilo.id}`
      const testo = `💪 ${profilo.nome} ti invita su FitProgress nel gruppo "${gruppoSel.nome}"!\n\nRegistrati qui per iniziare:\n${link}`
      setLinkInvito({ link, testo, email })
      setEmailInvitoStato(null)
      setMostraAggiungi(false)
      setInvitoNonIscritto(true)
    }
  }

  async function inviaEmailInvito() {
    if (!linkInvito) return
    setEmailInvitoStato('invio')
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(funzioneUrl('send-gift-email'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session?.access_token}`,
        },
        body: JSON.stringify({
          tipo: 'invito_gruppo_non_iscritto',
          destinatario_email: linkInvito.email,
          link: linkInvito.link,
          mittente_nome: `${profilo.nome} ${profilo.cognome || ''}`.trim(),
          gruppo_nome: gruppoSel.nome,
        }),
      })
      if (!res.ok) throw new Error('invio fallito')
      setEmailInvitoStato('ok')
    } catch {
      setEmailInvitoStato('errore')
    }
  }

  function chiediAnnullaInvito(membroId, nomeAtleta) {
    setConferma({
      titolo: 'Annullare l\'invito?',
      testo: `L'invito a ${nomeAtleta} verrà annullato. Potrai invitarlo di nuovo in seguito.`,
      testoConferma: 'Annulla invito', distruttiva: true,
      onConferma: () => { setConferma(null); annullaInvito(membroId) },
    })
  }

  async function annullaInvito(membroId) {
    await supabase.from('gruppo_membri').update({ stato: 'annullato' }).eq('id', membroId)
    toast_msg('Invito annullato')
    caricaMembri()
  }

  function chiediRimuoviMembro(atletaId, nome) {
    setConferma({
      titolo: 'Rimuovere dal gruppo?',
      testo: `${nome || 'Questo atleta'} non farà più parte del gruppo. I risultati già registrati restano salvati.`,
      testoConferma: 'Rimuovi', distruttiva: true,
      onConferma: () => { setConferma(null); rimuoviMembro(atletaId) },
    })
  }

  async function rimuoviMembro(atletaId) {
    await supabase.from('gruppo_membri').update({ stato: 'rimosso' }).eq('gruppo_id', gruppoSel.id).eq('utente_id', atletaId)
    caricaMembri()
    toast_msg('Membro rimosso')
  }

  async function assegnaSessione(sessioneId, data) {
    // Una data passata non arriva a nessuno: l'atleta vede solo le sessioni da
    // oggi in avanti, e nello storico comparirebbe come "Svolta" senza che
    // nessuno l'abbia svolta. Il campo ha già min={oggi}, ma su alcuni browser
    // si può ancora digitare a mano.
    if (data < oggiISO()) {
      toast_msg('Non puoi programmare una sessione in una data passata')
      return
    }
    // Stessa sessione, stessa data, due volte: all'atleta compariva doppia in
    // agenda, senza modo di capire quale svolgere.
    const { data: giaProgrammata } = await supabase.from('sessioni_calendario')
      .select('id').eq('gruppo_id', gruppoSel.id).eq('sessione_tipo_id', sessioneId)
      .eq('data', data).eq('archiviata', false).limit(1)
    if (giaProgrammata?.length) {
      toast_msg('Questa sessione è già in calendario per quella data')
      return
    }
    const { error } = await supabase.from('sessioni_calendario').insert({ sessione_tipo_id: sessioneId, gruppo_id: gruppoSel.id, gestore_id: profilo.id, data })
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('✅ Sessione assegnata al calendario!')
    caricaCalendario()
    const ids = await membriAttiviIds()
    if (ids.length) {
      const dataFormattata = new Date(data + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })
      creaNotifiche(ids, 'sessione', 'Nuova sessione', `Il coach ha programmato una sessione per ${dataFormattata}`)
    }
  }

  async function inviaMessaggioGruppo() {
    const testo = testoMessaggio.trim()
    if (!testo) { toast_msg('Scrivi il messaggio'); return }
    setInviandoMessaggio(true)
    const { error } = await supabase.from('messaggi').insert({ mittente_id: profilo.id, gruppo_id: gruppoSel.id, testo })
    setInviandoMessaggio(false)
    if (error) { toast_msg('Errore: ' + error.message); return }
    setTestoMessaggio('')
    setMostraMessaggio(false)
    toast_msg('✅ Messaggio inviato al gruppo!')
    const ids = (await membriAttiviIds()).filter(id => id !== profilo.id)
    if (ids.length) {
      creaNotifiche(ids, 'messaggio', 'Nuovo messaggio del coach', `${profilo.nome}: ${testo.substring(0, 100)}`)
    }
  }

  function toast_msg(msg) { setToast(msg); setTimeout(() => setToast(''), 2500) }

  // ── ELIMINARE SENZA TOCCARE I PROGRESSI DEGLI ATLETI ──
  // Una sessione che nessuno ha ancora svolto si elimina davvero. Se invece qualche
  // atleta ha già registrato risultati, la sessione viene ARCHIVIATA: sparisce dalle
  // liste del coach, ma resta nel database e quindi nello storico, nei report e nei
  // progressi degli atleti. Prima l'eliminazione cancellava anche i loro risultati.
  //
  // Il controllo lo fa il database (calendari_con_risultati): con le regole RLS il
  // coach non vede i risultati di chi non è più membro del gruppo, e l'app li
  // avrebbe considerati inesistenti. Restituisce null se il controllo fallisce:
  // in quel caso NON si elimina nulla.
  async function calendariConRisultati(ids) {
    if (!ids || ids.length === 0) return new Set()
    const { data, error } = await supabase.rpc('calendari_con_risultati', { ids })
    if (error) return null
    return new Set((data || []).map(r => (typeof r === 'string' ? r : r.calendari_con_risultati)))
  }

  async function rimuoviDalCalendario(id) {
    const conRisultati = await calendariConRisultati([id])
    if (!conRisultati) { toast_msg('Impossibile verificare la sessione, riprova'); return }
    if (conRisultati.has(id)) {
      await supabase.from('sessioni_calendario').update({ archiviata: true }).eq('id', id)
      toast_msg('Tolta dal calendario · i risultati degli atleti restano nel loro storico')
    } else {
      await supabase.from('sessioni_calendario').delete().eq('id', id)
      toast_msg('Sessione rimossa dal calendario')
    }
    caricaCalendario()
    setConfermaRimuovi(null)
  }

  async function salvaRinomina() {
    if (!rinominaNome.trim()) { toast_msg('Il nome non può essere vuoto'); return }
    const nuovo = rinominaNome.trim()
    const { error } = await supabase.from('gruppi').update({ nome: nuovo }).eq('id', gruppoSel.id)
    if (error) { toast_msg('Errore: ' + error.message); return }
    setGruppoSel(g => ({ ...g, nome: nuovo }))
    // L'elenco dei gruppi va aggiornato anche lui: prima si rinominava, si
    // tornava indietro e la card mostrava ancora il nome vecchio — sembrava
    // che il salvataggio non fosse andato a buon fine.
    setGruppi(gs => gs.map(g => g.id === gruppoSel.id ? { ...g, nome: nuovo } : g))
    setRinominaMode(false)
    toast_msg('Nome aggiornato!')
  }

  async function eliminaSessione(sessioneId) {
    const { data: date, error: errDate } = await supabase.from('sessioni_calendario').select('id').eq('sessione_tipo_id', sessioneId)
    if (errDate) { toast_msg('Impossibile verificare la sessione, riprova'); return }
    const ids = (date || []).map(d => d.id)
    const conRisultati = await calendariConRisultati(ids)
    if (!conRisultati) { toast_msg('Impossibile verificare la sessione, riprova'); return }
    const daArchiviare = ids.filter(i => conRisultati.has(i))
    const daEliminare = ids.filter(i => !conRisultati.has(i))
    // Le date mai svolte (anche future) si eliminano sempre
    if (daEliminare.length > 0) await supabase.from('sessioni_calendario').delete().in('id', daEliminare)
    if (daArchiviare.length > 0) {
      // Svolta da qualcuno: si archiviano le date svolte e il modello, così lo storico
      // degli atleti mantiene nome e contenuto della sessione
      await supabase.from('sessioni_calendario').update({ archiviata: true }).in('id', daArchiviare)
      await supabase.from('sessioni_tipo').update({ archiviata: true }).eq('id', sessioneId)
      toast_msg('Sessione eliminata · i risultati degli atleti restano nel loro storico')
    } else {
      await supabase.from('sessioni_tipo').delete().eq('id', sessioneId)
      toast_msg('Sessione eliminata')
    }
    setConfermaEliminaSessione(null)
    caricaSessioni()
    caricaCalendario()
  }

  async function duplicaSessione(sessione) {
    // Crea una copia della sessione con nome "<nome> (copia)"
    const nuovoNome = `${sessione.nome} (copia)`
    const { error } = await supabase.from('sessioni_tipo').insert({
      gruppo_id: gruppoSel.id,
      gestore_id: profilo.id,   // ← fix RLS: campo obbligatorio
      nome: nuovoNome,
      descrizione: sessione.descrizione || null,
      durata_minuti: sessione.durata_minuti || 60,
      blocchi: sessione.blocchi || [],
    })
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg('✅ Sessione duplicata!')
    caricaSessioni()
  }

  async function modificaDataCalendario() {
    if (!modificaCalData) return
    if (modificaCalData < oggiISO()) {
      toast_msg('Non puoi spostare una sessione in una data passata')
      return
    }
    const { error } = await supabase.from('sessioni_calendario').update({ data: modificaCalData }).eq('id', modificaCalId)
    if (error) { toast_msg('Errore: ' + error.message); return }
    setModificaCalId(null)
    caricaCalendario()
    toast_msg('Data aggiornata!')
    const ids = await membriAttiviIds()
    if (ids.length) {
      const dataFormattata = new Date(modificaCalData + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })
      creaNotifiche(ids, 'sessione', 'Sessione riprogrammata', `Il coach ha spostato una sessione al ${dataFormattata}`)
    }
  }

  async function creaNotifiche(utente_ids, tipo, titolo, testo) {
    if (!utente_ids?.length) return
    const notifiche = utente_ids.map(uid => ({
      utente_id: uid,
      tipo,
      titolo,
      testo,
    }))
    const { error } = await supabase.from('notifiche').insert(notifiche)
    // Una notifica rifiutata dal database passava inosservata: il coach leggeva
    // "✅ fatto" e gli atleti non ricevevano niente.
    if (error) {
      console.error('[notifiche] insert rifiutata:', error)
      toast_msg('Salvato, ma la notifica agli atleti non è partita')
    }
  }

  const COLORS = ['rgba(127,214,61,0.15)','rgba(87,184,255,0.15)','rgba(74,222,128,0.15)','rgba(255,120,87,0.15)','rgba(199,125,255,0.15)']
  const TCOLORS = ['var(--accent)','var(--accent2)','var(--green)','var(--accent3)','var(--purple)']

  if (reportAtleta) return <ReportAtleta atleta={reportAtleta} gruppoId={gruppoSel?.id} onChiudi={() => setReportAtleta(null)} />
  if (modificaSessione) return <CreaSessione gruppoId={gruppoSel?.id} sessioneEsistente={modificaSessione} onSalvato={() => { setModificaSessione(null); caricaSessioni() }} onAnnulla={() => setModificaSessione(null)} />
  if (creaSessione) return <CreaSessione gruppoId={gruppoSel?.id} onSalvato={() => { setCreaSessione(false); caricaSessioni() }} onAnnulla={() => setCreaSessione(false)} />

  // Vista gruppo selezionato
  if (gruppoSel) return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={() => { setGruppoSel(null); setRinominaMode(false) }}>←</button>
        {rinominaMode ? (
          <div style={{ flex: 1, display: 'flex', gap: 6, alignItems: 'center', margin: '0 8px' }}>
            <input className="form-input" value={rinominaNome} onChange={e => setRinominaNome(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') salvaRinomina(); if (e.key === 'Escape') setRinominaMode(false) }} autoFocus style={{ fontSize: 14, padding: '6px 10px', flex: 1 }} />
            <button className="btn btn-primary btn-sm" onClick={salvaRinomina}>✓</button>
            <button onClick={() => setRinominaMode(false)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>×</button>
          </div>
        ) : (
          <div onClick={() => { setRinominaNome(gruppoSel.nome); setRinominaMode(true) }} style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, cursor: 'pointer', flex: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }} title="Clicca per rinominare">
            {gruppoSel.nome} <span style={{ fontSize: 11, color: 'var(--muted)' }}>✏️</span>
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button onClick={() => setMostraMessaggio(true)} title="Messaggio al gruppo" aria-label="Messaggio al gruppo" style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>💬</button>
        </div>
      </div>

      {/* Barra tab: scorrevole in orizzontale, altrimenti su schermi stretti
          l'ultimo tab (Adesioni) resta tagliato e irraggiungibile.
          Il nome del gruppo non è ripetuto qui: è già nella topbar sopra. */}
      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', padding: '0 20px', overflowX: 'auto', scrollbarWidth: 'none' }}>
      {[{ id: 'membri', label: `👥 Membri (${membri.length})` }, { id: 'sessioni', label: '📋 Sessioni' }, { id: 'calendario', label: '📅 Calendario' }, { id: 'adesioni', label: '📣 Adesioni' }].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{ padding: '12px 14px', background: 'none', border: 'none', borderBottom: `2px solid ${tab === t.id ? 'var(--accent)' : 'transparent'}`, color: tab === t.id ? 'var(--accent)' : 'var(--muted)', fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: 'Syne', whiteSpace: 'nowrap', flexShrink: 0 }}>{t.label}</button>
        ))}
      </div>

      <div className="scroll-area">

        {/* Messaggio al gruppo: una scheda vera, non il prompt del browser */}
        {mostraMessaggio && (
          <div className="card slide-up">
            <div className="card-header">
              <div className="card-title">💬 Messaggio al gruppo</div>
              <button onClick={() => setMostraMessaggio(false)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>✕</button>
            </div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.5 }}>
                Lo riceveranno i {membri.length} {membri.length === 1 ? 'atleta attivo' : 'atleti attivi'} del gruppo, con una notifica.
              </div>
              <textarea className="form-input" value={testoMessaggio}
                onChange={e => setTestoMessaggio(e.target.value)}
                placeholder="Es. Domani ci vediamo alle 18 al parco, portate l'elastico."
                rows={4} maxLength={1000}
                style={{ resize: 'vertical', minHeight: 90, fontFamily: 'inherit' }} autoFocus />
              <div style={{ fontSize: 10, color: 'var(--muted)', textAlign: 'right', marginTop: -6 }}>{testoMessaggio.length} / 1000</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <button className="btn btn-secondary" onClick={() => { setMostraMessaggio(false); setTestoMessaggio('') }}>Annulla</button>
                <button className="btn btn-primary" onClick={inviaMessaggioGruppo} disabled={inviandoMessaggio || !testoMessaggio.trim()}>
                  {inviandoMessaggio ? 'Invio...' : 'Invia'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* TAB MEMBRI */}
        {tab === 'membri' && <>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 13, color: 'var(--muted)' }}>
              {membri.length} membri attivi
              {!coachPremium && <span style={{ color: 'var(--accent3)' }}> · {membri.length + membriPending.length}/3 piano Free</span>}
            </div>
            <button className="btn btn-primary btn-sm" onClick={() => setMostraAggiungi(true)}>+ Aggiungi</button>
          </div>

          {/* Link d'invito: il modo rapido per far entrare più atleti insieme */}
          <div className="card">
            <div className="card-body">
              {invito ? (
                <>
                  <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, marginBottom: 6 }}>🔗 Link d'invito</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 10, lineHeight: 1.45 }}>
                    Condividilo con i tuoi atleti: chi lo apre ti invia una richiesta, che approvi tu.
                    Scade il {new Date(invito.scadenza).toLocaleDateString('it-IT', { day: 'numeric', month: 'long' })}.
                  </div>
                  <div style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 10, padding: '10px 12px', fontSize: 11, color: 'var(--muted)', wordBreak: 'break-all', marginBottom: 10 }}>
                    {urlInvito(invito)}
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button className="btn btn-primary btn-sm" style={{ flex: 1 }} onClick={copiaLink}>📋 Copia link</button>
                    <button className="btn btn-secondary btn-sm" onClick={revocaInvito}>Revoca</button>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, marginBottom: 6 }}>🔗 Invita con un link</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 10, lineHeight: 1.45 }}>
                    Invece di inserire le email una per una, crea un link da mandare nel gruppo della palestra.
                    Resta valido 30 giorni e approvi tu chi entra.
                  </div>
                  <button className="btn btn-primary btn-sm" onClick={creaInvito} disabled={creandoInvito} style={{ width: '100%' }}>
                    {creandoInvito ? 'Creazione...' : '🔗 Crea link d\'invito'}
                  </button>
                </>
              )}
            </div>
          </div>

          {/* Richieste arrivate dal link: le approva il coach */}
          {richieste.length > 0 && (
            <div className="card" style={{ border: '1px solid rgba(255,120,87,0.35)' }}>
              <div className="card-header">
                <div className="card-title">🙋 Richieste di ingresso ({richieste.length})</div>
              </div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {richieste.map(r => (
                  <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: 140 }}>
                      <div style={{ fontWeight: 700, fontSize: 14 }}>{r.profili?.nome} {r.profili?.cognome}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)' }}>{r.profili?.email}</div>
                    </div>
                    <button className="btn btn-primary btn-sm" onClick={() => rispondiRichiesta(r.id, r.profili?.nome, true)}>✓ Approva</button>
                    <button className="btn btn-secondary btn-sm" onClick={() => rispondiRichiesta(r.id, r.profili?.nome, false)}>Rifiuta</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {mostraAggiungi && (
            <div className="card slide-up">
              <div className="card-header">
                <div className="card-title">➕ Aggiungi membro</div>
                <button onClick={() => setMostraAggiungi(false)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>✕</button>
              </div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div className="alert alert-info" style={{ fontSize: 12 }}>
                  <span>ℹ️</span><span>Inserisci l'email dell'atleta. Se è già iscritto riceverà una notifica nell'app. Altrimenti riceverà un link per registrarsi.</span>
                </div>
                <div className="form-group">
                  <label className="form-label">Email utente</label>
                  <input className="form-input" type="email" value={emailInvito} onChange={e => setEmailInvito(e.target.value)} placeholder="utente@email.com" onKeyDown={e => e.key === 'Enter' && invitaMembro()} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <button className="btn btn-secondary" onClick={() => setMostraAggiungi(false)}>Annulla</button>
                  <button className="btn btn-primary" onClick={invitaMembro}>Invia invito</button>
                </div>
              </div>
            </div>
          )}

          {membri.length === 0 ? (
            <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '30px 16px' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>👥</div>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, marginBottom: 8 }}>Nessun membro ancora</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16 }}>Aggiungi i tuoi atleti con la loro email.</div>
              <button className="btn btn-primary" onClick={() => setMostraAggiungi(true)}>+ Aggiungi primo membro</button>
            </div></div>
          ) : (
            <div className="card">
              <div style={{ padding: '0 16px' }}>
                {membri.map((m, i) => (
                  <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 0', borderBottom: i < membri.length - 1 ? '1px solid var(--border)' : 'none' }}>
                    <div className="avatar" style={{ background: COLORS[i % 5], color: TCOLORS[i % 5], width: 42, height: 42 }}>
                      {m.profili?.nome?.[0]}{m.profili?.cognome?.[0]}
                    </div>
                    <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => setReportAtleta({ ...m.profili, utente_id: m.utente_id, atleta_id: m.utente_id })}>
                      <div style={{ fontWeight: 600 }}>{m.profili?.nome} {m.profili?.cognome}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                        {m.profili?.piano} · aggiunto {new Date(m.data_ingresso).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' })}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                      {/* Rimuovi non deve avere lo stesso peso dell'azione utile:
                          erano impilati, adiacenti e della stessa dimensione */}
                      <button onClick={() => setReportAtleta({ ...m.profili, utente_id: m.utente_id, atleta_id: m.utente_id })} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '6px 12px', color: 'var(--accent2)', cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'Syne' }}>📊 Progressi</button>
                      <button onClick={() => chiediRimuoviMembro(m.utente_id, m.profili?.nome)} title="Rimuovi dal gruppo" aria-label="Rimuovi dal gruppo"
                        style={{ background: 'none', border: 'none', padding: '6px', color: 'var(--muted)', cursor: 'pointer', fontSize: 15 }}>✕</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Modale link invito non iscritto */}
          {invitoNonIscritto && linkInvito && (
            <div className="card slide-up" style={{ border: '1px solid rgba(127,214,61,0.3)' }}>
              <div className="card-header">
                <div className="card-title">📨 Utente non ancora iscritto</div>
                <button onClick={() => { setInvitoNonIscritto(false); setLinkInvito(null) }}
                  style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>✕</button>
              </div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{ background: 'rgba(251,191,36,0.15)', border: '1px solid rgba(251,191,36,0.4)', borderRadius: 10, padding: '12px 14px', display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 18, flexShrink: 0 }}>⚠️</span>
                  <div style={{ fontSize: 13, color: '#fbbf24', lineHeight: 1.5, fontWeight: 600 }}>
                    Questa email non è ancora registrata su FitProgress.<br />
                    <span style={{ fontWeight: 400, color: 'var(--text)' }}>Condividi il link per invitarlo a registrarsi.</span>
                  </div>
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)', textAlign: 'center', padding: '2px 0' }}>
                  Scegli come inviare il link di registrazione:
                </div>
                <button className="btn btn-primary"
                  onClick={() => { if (emailInvitoStato !== 'invio') inviaEmailInvito() }}
                  disabled={emailInvitoStato === 'invio'}
                  style={{
                    background: emailInvitoStato === 'ok' ? 'rgba(74,222,128,0.2)' : emailInvitoStato === 'errore' ? 'rgba(248,113,113,0.2)' : undefined,
                    border: emailInvitoStato === 'ok' ? '2px solid rgba(74,222,128,0.6)' : emailInvitoStato === 'errore' ? '2px solid rgba(248,113,113,0.6)' : undefined,
                    color: emailInvitoStato === 'ok' ? '#4ade80' : emailInvitoStato === 'errore' ? '#f87171' : undefined,
                    cursor: emailInvitoStato === 'invio' ? 'wait' : 'pointer',
                  }}>
                  {emailInvitoStato === 'invio' ? '⏳ Invio in corso...' : emailInvitoStato === 'ok' ? '✓ Email inviata!' : emailInvitoStato === 'errore' ? '⚠ Errore — riprova' : '📧 Invia via email'}
                </button>
                {emailInvitoStato === 'ok' && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(74,222,128,0.1)', border: '1px solid rgba(74,222,128,0.3)', borderRadius: 10, padding: '10px 14px' }}>
                    <span style={{ fontSize: 18 }}>✅</span>
                    <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                      <strong style={{ color: '#4ade80' }}>{linkInvito.email}</strong> riceverà il link per registrarsi ed entrare nel gruppo.
                    </div>
                  </div>
                )}
                <button className="btn btn-secondary" onClick={() => {
                  window.open(`https://wa.me/?text=${encodeURIComponent(linkInvito.testo)}`, '_blank')
                }}>📲 Invia su WhatsApp</button>
                <button className="btn btn-secondary" onClick={() => {
                  navigator.clipboard.writeText(linkInvito.link)
                  toast_msg('✓ Link copiato!')
                }}>📋 Copia link</button>
                <button className="btn btn-ghost" onClick={() => { setInvitoNonIscritto(false); setLinkInvito(null) }}>
                  Chiudi
                </button>
              </div>
            </div>
          )}

          {/* Lista inviti in attesa */}
          {membriPending.length > 0 && (
            <div className="card" style={{ border: '1px solid rgba(251,191,36,0.3)' }}>
              <div className="card-header" style={{ background: 'rgba(251,191,36,0.06)' }}>
                <div className="card-title" style={{ color: 'var(--accent)' }}>⏳ Inviti in attesa ({membriPending.length})</div>
              </div>
              <div style={{ padding: '0 16px' }}>
                {membriPending.map((m, i) => (
                  <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: i < membriPending.length - 1 ? '1px solid var(--border)' : 'none' }}>
                    <div className="avatar" style={{ background: 'rgba(251,191,36,0.15)', color: '#fbbf24', width: 38, height: 38, fontSize: 13 }}>
                      {m.profili?.nome?.[0]}{m.profili?.cognome?.[0]}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{m.profili?.nome} {m.profili?.cognome}</div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                        Invitato il {new Date(m.creato_il).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' })} · scade in{' '}
                        {Math.max(0, 7 - Math.floor((Date.now() - new Date(m.creato_il)) / 86400000))} giorni
                      </div>
                    </div>
                    <button onClick={() => chiediAnnullaInvito(m.id, m.profili?.nome)}
                      style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '4px 10px', color: 'var(--muted)', cursor: 'pointer', fontSize: 11 }}>
                      Annulla
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>}

        {/* TAB SESSIONI */}
        {tab === 'sessioni' && <>

          {/* Modal assegna data */}
          {assegnaSessione_id && (
            <div className="card slide-up">
              <div className="card-header">
                <div className="card-title">Assegna sessione</div>
                <button onClick={() => setAssegnaSessione_id(null)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>x</button>
              </div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Data sessione</label>
                  {/* min: una data passata non la vedrebbe nessun atleta. Il campo
                      delle Adesioni aveva già il minimo, questo no. */}
                  <input className="form-input" type="date" value={assegnaData} min={oggiISO()} onChange={e => setAssegnaData(e.target.value)} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <button className="btn btn-secondary" onClick={() => setAssegnaSessione_id(null)}>Annulla</button>
                  <button className="btn btn-primary" onClick={() => { assegnaSessione(assegnaSessione_id, assegnaData); setAssegnaSessione_id(null) }}>Conferma</button>
                </div>
              </div>
            </div>
          )}

          {confermaEliminaSessione && (
            <div className="card slide-up" style={{ border: '1px solid rgba(248,113,113,0.3)' }}>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15 }}>Elimina sessione</div>
                <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>Vuoi eliminare <strong style={{ color: 'var(--text)' }}>{confermaEliminaSessione.nome}</strong>?</div>
                <div style={{ fontSize: 12, color: 'var(--accent3)', background: 'rgba(255,120,87,0.08)', borderRadius: 10, padding: '8px 12px', border: '1px solid rgba(255,120,87,0.2)' }}>Verranno eliminate anche le date in calendario. Se qualche atleta l'ha già svolta, i suoi risultati restano nel suo storico e nei progressi.</div>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setConfermaEliminaSessione(null)}>Annulla</button>
                  <button className="btn btn-danger" style={{ flex: 1 }} onClick={() => eliminaSessione(confermaEliminaSessione.id)}>Elimina</button>
                </div>
              </div>
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 13, color: 'var(--muted)' }}>{sessioni.length} {sessioni.length === 1 ? 'sessione creata' : 'sessioni create'}</div>
            <button className="btn btn-primary btn-sm" onClick={() => setCreaSessione(true)}>+ Crea</button>
          </div>

          {/* Sessioni archiviate: quelle già svolte che il coach ha tolto dalla lista.
              Restano qui per poterle ripristinare — l'archiviazione non è una via senza ritorno. */}
          {sessioniArchiviate.length > 0 && (
            <div style={{ marginTop: 4 }}>
              <button onClick={() => setMostraArchiviate(v => !v)}
                style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 10, padding: '9px 14px', width: '100%',
                  color: 'var(--muted)', cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'Syne',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>📦 Sessioni archiviate ({sessioniArchiviate.length})</span>
                <span>{mostraArchiviate ? '▾' : '▸'}</span>
              </button>
              {mostraArchiviate && (
                <div style={{ marginTop: 8 }}>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 8, lineHeight: 1.5 }}>
                    Eliminate dalla tua lista, ma già svolte da qualche atleta: restano nel loro storico e nei loro progressi.
                  </div>
                  {sessioniArchiviate.map(s2 => (
                    <div key={s2.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10,
                      background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: '10px 14px', marginBottom: 6 }}>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 13 }}>{s2.nome}</div>
                        <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                          {s2.durata_minuti} min · {(s2.blocchi || []).length} {(s2.blocchi || []).length === 1 ? 'blocco' : 'blocchi'}
                        </div>
                      </div>
                      <button onClick={() => ripristinaSessione(s2.id)} className="btn btn-secondary btn-sm" style={{ flexShrink: 0 }}>↩︎ Ripristina</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {sessioni.length === 0 ? (
            <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '30px 16px' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, marginBottom: 8 }}>Nessuna sessione ancora</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16, lineHeight: 1.6 }}>Crea sessioni con blocchi multipli — EMOM, Tabata, Classico, AMRAP e altro.</div>
              <button className="btn btn-primary" onClick={() => setCreaSessione(true)}>⚡ Crea prima sessione</button>
            </div></div>
          ) : sessioni.map(s => {
            // Anche le date passate contano: "calendario" contiene solo le future, quindi
            // una sessione già svolta risultava "non programmata" e mostrava l'avviso
            // "non è visibile agli atleti" — il contrario del vero.
            const futura = calendario.find(c => c.sessione_tipo_id === s.id)
            const passata = calendarioPassate.find(c => c.sessione_tipo_id === s.id)
            const programmata = !!(futura || passata)
            return (
            <div key={s.id} className="card" style={{ border: programmata ? '1px solid var(--border)' : '1px solid rgba(255,120,87,0.3)' }}>
              {/* Intestazione: titolo a sinistra, azioni secondarie a destra.
                  L'azione principale (data) sta su una riga propria più sotto: prima erano
                  tutte e quattro sulla stessa riga e andavano a capo schiacciando il titolo.
                  Ogni icona ha un aria-label: il "title" da solo non compare mai al tocco. */}
              <div className="card-header">
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div className="card-title">{s.nome}</div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{s.durata_minuti} min · {(s.blocchi || []).length} {(s.blocchi || []).length === 1 ? 'blocco' : 'blocchi'} · {(() => { const n = (s.blocchi || []).reduce((acc, b) => acc + (b.esercizi?.length || 0), 0); return `${n} ${n === 1 ? 'esercizio' : 'esercizi'}` })()}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0, marginLeft: 8 }}>
                  <button onClick={() => setModificaSessione(s)} title="Modifica sessione" aria-label="Modifica sessione"
                    style={{ background: 'rgba(127,214,61,0.1)', border: '1px solid rgba(127,214,61,0.35)', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 16 }}>✏️</button>
                  <button onClick={() => duplicaSessione(s)} title="Duplica sessione" aria-label="Duplica sessione"
                    style={{ background: 'rgba(87,184,255,0.1)', border: '1px solid rgba(87,184,255,0.35)', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 16 }}>📑</button>
                  {/* Elimina staccata dalle altre: adiacente a "Duplica" era facile sbagliare tocco */}
                  <button onClick={() => setConfermaEliminaSessione(s)} title="Elimina sessione" aria-label="Elimina sessione"
                    style={{ background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.35)', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 16, marginLeft: 6 }}>🗑️</button>
                </div>
              </div>
              <div style={{ padding: '10px 16px 0' }}>
                {programmata
                  ? <button onClick={() => { const cal = futura || passata; setModificaCalId(cal.id); setModificaCalData(cal.data); setTab('calendario') }} className="btn btn-secondary btn-sm" style={{ background: 'rgba(87,184,255,0.15)', border: '1px solid rgba(87,184,255,0.4)', color: 'var(--accent2)', width: '100%' }}>📅 {futura ? 'Modifica data' : 'Riprogramma'}</button>
                  : <button onClick={() => { setAssegnaSessione_id(s.id); setAssegnaData(oggiISO()) }} className="btn btn-primary btn-sm" style={{ width: '100%' }}>📅 Assegna data</button>
                }
              </div>
              {/* Avviso esplicito: una sessione senza data non è visibile a nessun atleta */}
              {!programmata && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(255,120,87,0.08)', borderTop: '1px solid rgba(255,120,87,0.2)', padding: '8px 16px' }}>
                  <span style={{ fontSize: 13, flexShrink: 0 }}>⚠️</span>
                  <span style={{ fontSize: 11, color: 'var(--accent3)', lineHeight: 1.4 }}>
                    Senza una data in calendario questa sessione non è visibile agli atleti
                  </span>
                </div>
              )}
              {s.descrizione && <div className="card-body" style={{ fontSize: 12, color: 'var(--muted)' }}>{s.descrizione}</div>}
              {(s.blocchi || []).length > 0 && (
                <div style={{ padding: '0 16px 12px' }}>
                  {s.blocchi.map((b, i) => {
                    const icone = ICONA_FORMATO
                    return (
                      <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '4px 0', fontSize: 12, color: 'var(--muted)' }}>
                        <span>{icone[b.formato] || '▪️'}</span>
                        <span style={{ color: 'var(--text)' }}>{b.nome || `Blocco ${i + 1}`}</span>
                        <span>·</span>
                        <span>{nomeFormato(b.formato)}</span>
                        <span>·</span>
                        <span>{b.esercizi?.length || 0} {(b.esercizi?.length || 0) === 1 ? 'esercizio' : 'esercizi'}</span>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
            )
          })}
        </>}

        {/* TAB CALENDARIO */}
        {tab === 'calendario' && <>
          {/* Toggle prossime/passate */}
          <div style={{ display: 'flex', gap: 0, background: 'var(--surface2)', borderRadius: 10, padding: 3, marginBottom: 4 }}>
            {[{ id: 'prossime', label: '📅 Prossime' }, { id: 'passate', label: '📂 Storico' }].map(v => (
              <button key={v.id} onClick={() => setVistaCalendario(v.id)} style={{
                flex: 1, padding: '7px 0', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'Syne',
                background: vistaCalendario === v.id ? 'var(--surface)' : 'transparent',
                color: vistaCalendario === v.id ? 'var(--accent)' : 'var(--muted)',
                boxShadow: vistaCalendario === v.id ? '0 1px 4px rgba(0,0,0,0.2)' : 'none',
              }}>{v.label}</button>
            ))}
          </div>
          {vistaCalendario === 'prossime' ? (<>
          {/* Modal conferma rimuovi */}
          {confermaRimuovi && (
            <div className="card slide-up" style={{ border: '1px solid rgba(248,113,113,0.3)' }}>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15 }}>Rimuovere la sessione?</div>
                <div style={{ fontSize: 13, color: 'var(--muted)' }}>La sessione verrà rimossa dal calendario. Se qualche atleta l'ha già svolta, i suoi risultati restano nel suo storico e nei progressi.</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <button className="btn btn-secondary" onClick={() => setConfermaRimuovi(null)}>Annulla</button>
                  <button className="btn btn-danger" onClick={() => rimuoviDalCalendario(confermaRimuovi)}>Rimuovi</button>
                </div>
              </div>
            </div>
          )}

          {/* Modal modifica data */}
          {modificaCalId && (
            <div className="card slide-up">
              <div className="card-header">
                <div className="card-title">Modifica data</div>
                <button onClick={() => setModificaCalId(null)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>x</button>
              </div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div className="form-group">
                  <label className="form-label">Nuova data</label>
                  <input className="form-input" type="date" value={modificaCalData} min={oggiISO()} onChange={e => setModificaCalData(e.target.value)} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  <button className="btn btn-secondary" onClick={() => setModificaCalId(null)}>Annulla</button>
                  <button className="btn btn-primary" onClick={modificaDataCalendario}>Salva</button>
                </div>
              </div>
            </div>
          )}

          {calendario.length === 0 ? (
            <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '24px', fontSize: 13, color: 'var(--muted)' }}>
              Nessuna sessione in calendario.<br />Vai su "Sessioni" e clicca "Assegna".
            </div></div>
          ) : calendario.map(c => (
            <div key={c.id} style={{ background: 'var(--surface)', borderRadius: 12, padding: '14px 16px', border: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div style={{ textAlign: 'center', background: 'var(--surface2)', borderRadius: 10, padding: '8px 12px', flexShrink: 0 }}>
                  <div style={{ fontFamily: 'Syne', fontWeight: 600, fontSize: 20, color: 'var(--accent)', lineHeight: 1 }}>{new Date(c.data + 'T00:00:00').getDate()}</div>
                  <div style={{ fontSize: 10, fontWeight: 400, color: 'var(--muted)', textTransform: 'uppercase' }}>{new Date(c.data + 'T00:00:00').toLocaleDateString('it-IT', { month: 'short' })}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{c.sessioni_tipo?.nome || 'Sessione'}</div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                    {new Date(c.data + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'long' })}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => { setModificaCalId(c.id); setModificaCalData(c.data) }} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '4px 10px', color: 'var(--accent2)', cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>Modifica</button>
                  <button onClick={() => setConfermaRimuovi(c.id)} style={{ background: 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 8, padding: '4px 10px', color: 'var(--red)', cursor: 'pointer', fontSize: 11 }}>Rimuovi</button>
                </div>
              </div>
            </div>
          ))}
          </>) : (<>
          {/* STORICO sessioni passate */}
          {calendarioPassate.length === 0 ? (
            <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '24px', fontSize: 13, color: 'var(--muted)' }}>
              Nessuna sessione passata.
            </div></div>
          ) : calendarioPassate.map(c => (
            <div key={c.id} style={{ background: 'var(--surface)', borderRadius: 12, padding: '14px 16px', border: '1px solid var(--border)', opacity: 0.8 }}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div style={{ textAlign: 'center', background: 'var(--surface2)', borderRadius: 10, padding: '8px 12px', flexShrink: 0 }}>
                  <div style={{ fontFamily: 'Syne', fontWeight: 600, fontSize: 20, color: 'var(--muted)', lineHeight: 1 }}>{new Date(c.data + 'T00:00:00').getDate()}</div>
                  <div style={{ fontSize: 10, fontWeight: 400, color: 'var(--muted)', textTransform: 'uppercase' }}>{new Date(c.data + 'T00:00:00').toLocaleDateString('it-IT', { month: 'short' })}</div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{c.sessioni_tipo?.nome || 'Sessione'}</div>
                  <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                    {new Date(c.data + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                  </div>
                </div>
                <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 8, background: 'var(--surface2)', color: 'var(--muted)' }}>Svolta</span>
              </div>
            </div>
          ))}
          </>)}
        </>}

        {/* TAB ADESIONI nel gruppo */}
        {tab === 'adesioni' && (
          <AadesionisGruppo
            gruppoId={gruppoSel.id}
            gruppoNome={gruppoSel.nome}
            coachId={profilo.id}
            membri={membri}
            coachPremium={coachPremium}
            onRichiediUpgrade={onRichiediUpgrade}
          />
        )}

      </div>
      {conferma && <ModaleConferma {...conferma} onAnnulla={() => setConferma(null)} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  )

  // Vista lista gruppi
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <TopBar
        onIndietro={onCambiaTab ? () => onCambiaTab('home') : undefined}
        onNotifiche={undefined}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 20px 0' }}>
        <button className="btn btn-primary btn-sm" onClick={() => setCreaGruppo(true)}>+ Gruppo</button>
      </div>

      <div className="scroll-area fade-in">

        {/* Form crea gruppo */}
        {creaGruppo && (
          <div className="card slide-up">
            <div className="card-header">
              <div className="card-title">➕ Nuovo gruppo</div>
              <button onClick={() => setCreaGruppo(false)} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>✕</button>
            </div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div className="form-group"><label className="form-label">Nome gruppo *</label><input className="form-input" value={nomeGruppo} onChange={e => setNomeGruppo(e.target.value)} placeholder="es. Calisthenics Avanzato, Corso Sabato..." /></div>
              <div className="form-group"><label className="form-label">Descrizione</label><input className="form-input" value={descGruppo} onChange={e => setDescGruppo(e.target.value)} placeholder="Descrizione opzionale..." /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <button className="btn btn-secondary" onClick={() => setCreaGruppo(false)}>Annulla</button>
                <button className="btn btn-primary" onClick={creaNuovoGruppo}>Crea</button>
              </div>
            </div>
          </div>
        )}

        {/* Modale conferma elimina gruppo */}
        {confermaEliminaGruppo && (
          <div className="card slide-up" style={{ border: '1px solid rgba(248,113,113,0.3)' }}>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15 }}>🗑️ Elimina gruppo</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
                Vuoi eliminare <strong style={{ color: 'var(--text)' }}>{confermaEliminaGruppo.nome}</strong>?<br />
                Verranno eliminate anche tutte le sessioni e il calendario.
              </div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setConfermaEliminaGruppo(null)}>Annulla</button>
                <button className="btn btn-danger" style={{ flex: 1 }} onClick={() => eliminaGruppo(confermaEliminaGruppo)}>Elimina</button>
              </div>
            </div>
          </div>
        )}

        {/* Modale conferma esci da gruppo */}
        {confermaEsciGruppo && (
          <div className="card slide-up" style={{ border: '1px solid rgba(251,191,36,0.3)' }}>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15 }}>🚪 Esci dal gruppo</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
                Vuoi uscire dal gruppo <strong style={{ color: 'var(--text)' }}>{confermaEsciGruppo.nome}</strong>?
              </div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setConfermaEsciGruppo(null)}>Annulla</button>
                <button className="btn btn-primary" style={{ flex: 1, background: '#fbbf24', color: '#000' }} onClick={() => esciDaGruppo(confermaEsciGruppo)}>Esci</button>
              </div>
            </div>
          </div>
        )}

        {caricamento ? (
          <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 30 }}>Caricamento...</div>
        ) : (<>

          {/* ── GRUPPI CREATI DA ME ── */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <div>
              <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 16 }}>I miei gruppi</div>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>
                {gruppi.length} {gruppi.length === 1 ? 'gruppo creato' : 'gruppi creati'}
                {!coachPremium && <span style={{ color: 'var(--accent3)' }}> · {gruppi.length}/1 piano Free</span>}
              </div>
            </div>
          </div>

          {gruppi.length === 0 ? (
            <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '24px 16px' }}>
              <div style={{ fontSize: 40, marginBottom: 10 }}>👥</div>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15, marginBottom: 6 }}>Nessun gruppo ancora</div>
              <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 14, lineHeight: 1.6 }}>Crea un gruppo per iniziare a seguire i tuoi atleti.</div>
              <button className="btn btn-primary" onClick={() => setCreaGruppo(true)}>+ Crea primo gruppo</button>
            </div></div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
              {gruppi.map((g) => {
                const st = statsGruppi[g.id] || { membri: 0, pending: 0, sessioni: 0, prossima: null }
                // Primo passo mancante: guida il coach al prossimo passo invece di lasciarlo indovinare
                const manca = st.membri === 0 && st.pending === 0
                  ? { testo: 'Nessun atleta — invitane uno per iniziare', tab: 'membri', cta: 'Invita atleti' }
                  : st.sessioni === 0
                    ? { testo: 'Nessuna sessione — creane una per il gruppo', tab: 'sessioni', cta: 'Crea sessione' }
                    : !st.prossima
                      ? { testo: 'Nessuna sessione in calendario — assegna una data', tab: 'sessioni', cta: 'Assegna data' }
                      : null
                return (
                <div key={g.id} style={{ background: 'var(--surface)', borderRadius: 14, border: `1px solid ${manca ? 'rgba(255,120,87,0.3)' : 'var(--border)'}`, padding: '14px 16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div onClick={() => setGruppoSel(g)} style={{ flex: 1, cursor: 'pointer', minWidth: 0 }}>
                      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15 }}>{g.nome}</div>
                      {g.descrizione && <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{g.descrizione}</div>}
                      {/* Stato del gruppo: quello che serve davvero sapere a colpo d'occhio */}
                      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 5, display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                        <span>👥 {st.membri} {st.membri === 1 ? 'atleta' : 'atleti'}</span>
                        {st.pending > 0 && <span style={{ color: '#fbbf24' }}>· ⏳ {st.pending} in attesa</span>}
                        <span>· 📋 {st.sessioni} {st.sessioni === 1 ? 'sessione' : 'sessioni'}</span>
                        {st.prossima && (
                          <span style={{ color: 'var(--accent)', fontWeight: 700 }}>
                            · 📅 prossima {new Date(st.prossima + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' })}
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginLeft: 8, flexShrink: 0 }}>
                      <button onClick={() => setGruppoSel(g)} style={{ background: 'none', border: 'none', fontSize: 20, color: 'var(--muted)', cursor: 'pointer' }}>›</button>
                      <button onClick={(e) => { e.stopPropagation(); setMenuGruppo(menuGruppo === g.id ? null : g.id) }}
                        title="Altre azioni"
                        style={{ background: 'none', border: 'none', borderRadius: 8, padding: '4px 8px', color: 'var(--muted)', cursor: 'pointer', fontSize: 16, lineHeight: 1 }}>⋯</button>
                    </div>
                  </div>

                  {/* Richiamo al prossimo passo: senza questo il gruppo resta inutilizzato */}
                  {manca && (
                    <div onClick={() => { setTab(manca.tab); setGruppoSel(g) }}
                      style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(255,120,87,0.08)', border: '1px solid rgba(255,120,87,0.25)', borderRadius: 10, padding: '8px 12px', cursor: 'pointer' }}>
                      <span style={{ fontSize: 14, flexShrink: 0 }}>⚠️</span>
                      <span style={{ fontSize: 12, color: 'var(--accent3)', flex: 1, lineHeight: 1.4 }}>{manca.testo}</span>
                      <span style={{ fontSize: 11, fontWeight: 700, fontFamily: 'Syne', color: 'var(--accent3)', whiteSpace: 'nowrap' }}>{manca.cta} ›</span>
                    </div>
                  )}

                  {/* Azioni secondarie: nascoste dietro "⋯" per non competere col percorso principale */}
                  {menuGruppo === g.id && (
                    <div style={{ marginTop: 10, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                      <button onClick={(e) => { e.stopPropagation(); setMenuGruppo(null); setConferma({ titolo: 'Archiviare il gruppo?', testo: `"${g.nome}" verrà archiviato. Potrai ripristinarlo in seguito.`, testoConferma: 'Archivia', icona: '📦', onConferma: () => { setConferma(null); archiviaGruppo(g) } }) }}
                        style={{ background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.35)', borderRadius: 8, padding: '5px 12px', color: '#fbbf24', cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>📦 Archivia</button>
                      <button onClick={(e) => { e.stopPropagation(); setMenuGruppo(null); setConfermaEliminaGruppo(g) }}
                        style={{ background: 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 8, padding: '5px 12px', color: 'var(--red)', cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>🗑️ Elimina</button>
                    </div>
                  )}
                </div>
                )
              })}
            </div>
          )}

          {/* Gruppi archiviati */}
          {gruppiArchiviati.length > 0 && (
            <div style={{ marginTop: 8 }}>
              <button onClick={() => setMostraArchiviati(v => !v)}
                style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', padding: '4px 0', width: '100%' }}>
                <span style={{ fontSize: 14 }}>📦</span>
                <span style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 13, color: 'var(--muted)' }}>
                  Gruppi archiviati ({gruppiArchiviati.length})
                </span>
                <span style={{ color: 'var(--muted)', fontSize: 12, marginLeft: 'auto', transition: 'transform .2s', display: 'inline-block', transform: mostraArchiviati ? 'rotate(90deg)' : 'none' }}>›</span>
              </button>
              {mostraArchiviati && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
                  {gruppiArchiviati.map(g => (
                    <div key={g.id} style={{ background: 'var(--surface)', borderRadius: 14, border: '1px solid var(--border)', padding: '14px 16px', opacity: 0.7 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15, color: 'var(--muted)' }}>{g.nome}</div>
                          {g.descrizione && <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{g.descrizione}</div>}
                          <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4 }}>
                            📦 Archiviato · Creato il {new Date(g.creato_il).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' })}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginLeft: 8 }}>
                          <button onClick={() => ripristinaGruppo(g)}
                            title="Ripristina gruppo"
                            style={{ background: 'rgba(127,214,61,0.1)', border: '1px solid rgba(127,214,61,0.35)', borderRadius: 8, padding: '4px 10px', color: 'var(--accent)', cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>
                            Ripristina
                          </button>
                          <button onClick={() => setConferma({ titolo: 'Eliminare definitivamente?', testo: `"${g.nome}" e tutti i suoi dati verranno eliminati per sempre. L'operazione non è reversibile.`, testoConferma: 'Elimina per sempre', icona: '🗑️', distruttiva: true, onConferma: () => { setConferma(null); eliminaGruppo(g) } })}
                            title="Elimina gruppo"
                            style={{ background: 'none', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 8, padding: '4px 8px', color: 'var(--red)', cursor: 'pointer', fontSize: 12 }}>🗑️</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

        </>)}
      </div>
      {conferma && <ModaleConferma {...conferma} onAnnulla={() => setConferma(null)} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  )
}

/* ══════════════════════════════════════════
   ADESIONI dentro un gruppo specifico

   ATTENZIONE — questo componente è una SECONDA implementazione delle Adesioni:
   la prima, e quella corretta, è in PaginaAdesioni.js (vista coach, raggiunta
   dalla barra in basso). Averle doppie è la ragione di tre difetti che vivevano
   solo qui:

     · le notifiche agli atleti scrivevano nella colonna "dato_extra", che nella
       tabella notifiche NON ESISTE (si chiama "dati"): il database rifiutava la
       riga con un 400, l'esito non veniva controllato e il coach leggeva
       "✅ Appuntamento creato!" mentre nessun atleta riceveva niente;
     · le notifiche andavano a tutte le righe di gruppo_membri, anche a chi era
       stato rimosso o aveva rifiutato;
     · mancava il controllo del piano: Adesioni è Premium, e PaginaAdesioni.js lo
       fa rispettare, ma da qui un coach Free ci entrava liberamente.

   Prima o poi le due vanno unificate. Finché restano due, ogni correzione a una
   va riportata anche all'altra.
══════════════════════════════════════════ */
function AadesionisGruppo({ gruppoId, gruppoNome, coachId, membri, coachPremium, onRichiediUpgrade }) {
  const [appuntamenti, setAppuntamenti] = useState([])
  const [appSel, setAppSel] = useState(null)
  const [risposte, setRisposte] = useState([])
  const [mostraForm, setMostraForm] = useState(false)
  const [titoloForm, setTitoloForm] = useState('')
  const [dataForm, setDataForm] = useState('')
  const [oraForm, setOraForm] = useState('')
  const [noteForm, setNoteForm] = useState('')
  const [minForm, setMinForm] = useState('')
  const [salvataggio, setSalvataggio] = useState(false)
  const [toast, setToast] = useState('')
  const [confermaElimina, setConfermaElimina] = useState(null)
  const [vista, setVista] = useState('prossimi')

  const oggi = oggiISO()

  useEffect(() => { if (coachPremium) caricaAppuntamenti() }, [gruppoId, coachPremium])

  function toast_msg(msg) { setToast(msg); setTimeout(() => setToast(''), 3000) }

  // Adesioni è una funzione Premium, come già scritto nel profilo del coach
  // ("Il piano Free include 1 gruppo e fino a 3 atleti, senza Adesioni") e come
  // già applicato da PaginaAdesioni.js. Qui mancava.
  if (!coachPremium) {
    return (
      <div className="card" style={{ textAlign: 'center' }}>
        <div className="card-body" style={{ padding: '28px 22px', display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center' }}>
          <div style={{ fontSize: 40 }}>🔒</div>
          <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 16 }}>Adesioni è una funzione Premium</div>
          <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
            Proponi un allenamento a "{gruppoNome}" e raccogli chi c'è e chi non c'è, prima di andare in palestra.
          </div>
          <button className="btn btn-primary" style={{ width: '100%', marginTop: 4 }} onClick={onRichiediUpgrade}>
            ⚡ Passa a Premium — 6€/mese
          </button>
        </div>
      </div>
    )
  }

  async function caricaAppuntamenti() {
    const { data } = await supabase.from('adesioni_appuntamenti')
      .select('*')
      .eq('gruppo_id', gruppoId)
      .order('data', { ascending: true })
      .order('ora', { ascending: true })
    setAppuntamenti(data || [])
  }

  async function caricaRisposte(appId) {
    const { data } = await supabase.from('adesioni_risposte')
      .select('*, profili(nome, cognome)')
      .eq('appuntamento_id', appId)
    setRisposte(data || [])
  }

  /** Notifica agli atleti attivi del gruppo.
   *
   *  La colonna è "dati", non "dato_extra": quest'ultima non esiste e il
   *  database rispondeva 400. E l'esito ora viene controllato, perché una
   *  notifica che non parte è esattamente ciò che il coach non deve scoprire
   *  dai suoi atleti.
   */
  async function notificaGruppo(titolo, testo, appuntamentoId) {
    const destinatari = (membri || []).map(m => m.utente_id).filter(Boolean)
    if (destinatari.length === 0) return true
    const { error } = await supabase.from('notifiche').insert(
      destinatari.map(uid => ({
        utente_id: uid,
        tipo: 'adesione',
        titolo,
        testo,
        dati: JSON.stringify({ appuntamento_id: appuntamentoId }),
      }))
    )
    if (error) {
      console.error('[adesioni] notifiche non inviate:', error)
      return false
    }
    return true
  }

  async function crea() {
    if (!titoloForm || !dataForm || !oraForm) { toast_msg('Compila tutti i campi obbligatori'); return }
    setSalvataggio(true)
    const { data: nuovo, error } = await supabase.from('adesioni_appuntamenti').insert({
      gruppo_id: gruppoId,
      coach_id: coachId,
      titolo: titoloForm,
      data: dataForm,
      ora: oraForm,
      note: noteForm || null,
      min_partecipanti: minForm ? parseInt(minForm) : 0,
      stato: 'aperto',
    }).select().single()
    if (error) { toast_msg('Errore: ' + error.message); setSalvataggio(false); return }

    const dataFmt = new Date(dataForm + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })
    const inviate = await notificaGruppo(
      '📣 Nuovo appuntamento',
      `${titoloForm} — ${dataFmt} alle ${oraForm.slice(0, 5)} (${gruppoNome})`,
      nuovo.id,
    )

    setSalvataggio(false)
    setMostraForm(false)
    resetForm()
    toast_msg(inviate ? '✅ Appuntamento creato e atleti avvisati' : '⚠️ Appuntamento creato, ma la notifica agli atleti non è partita')
    caricaAppuntamenti()
  }

  async function cambiaStato(app, nuovoStato) {
    const { error } = await supabase.from('adesioni_appuntamenti').update({ stato: nuovoStato }).eq('id', app.id)
    if (error) { toast_msg('Errore: ' + error.message); return }

    const emoji = nuovoStato === 'confermato' ? '✅' : '❌'
    const testo = nuovoStato === 'confermato'
      ? `L'allenamento "${app.titolo}" è CONFERMATO!`
      : `L'allenamento "${app.titolo}" è stato annullato.`
    const inviate = nuovoStato === 'aperto'
      ? true   // la riapertura non si notifica, come in PaginaAdesioni
      : await notificaGruppo(`${emoji} Allenamento ${nuovoStato}`, testo, app.id)

    toast_msg(
      !inviate ? '⚠️ Stato aggiornato, ma la notifica agli atleti non è partita'
      : nuovoStato === 'confermato' ? '✅ Confermato!'
      : nuovoStato === 'annullato' ? '❌ Annullato'
      : '🔄 Riaperto')
    setAppSel(prev => prev ? { ...prev, stato: nuovoStato } : null)
    caricaAppuntamenti()
  }

  async function elimina(id) {
    const { error } = await supabase.from('adesioni_appuntamenti').delete().eq('id', id)
    if (error) { toast_msg('Errore: ' + error.message); return }
    setConfermaElimina(null)
    setAppSel(null)
    toast_msg('🗑️ Eliminato')
    caricaAppuntamenti()
  }

  function resetForm() { setTitoloForm(''); setDataForm(''); setOraForm(''); setNoteForm(''); setMinForm('') }

  const oraAdesso = new Date()
  const appFiltrati = appuntamenti.filter(a => {
    const passato = a.data < oggi || (a.data === oggi && a.ora < oraAdesso.toTimeString().slice(0, 8))
    return vista === 'prossimi' ? !passato : passato
  })

  const statoColor = { aperto: 'var(--accent)', confermato: 'var(--green)', annullato: 'var(--red)' }
  const statoLabel = { aperto: '🟡 Aperto', confermato: '✅ Confermato', annullato: '❌ Annullato' }

  // Dettaglio appuntamento
  if (appSel) {
    const si = risposte.filter(r => r.risposta === 'si')
    const no = risposte.filter(r => r.risposta === 'no')
    const dataFmt = new Date(appSel.data + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} className="fade-in">
        <button onClick={() => setAppSel(null)} style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: 13, fontWeight: 700, alignSelf: 'flex-start', padding: 0 }}>← Torna alla lista</button>
        <div className="card">
          <div className="card-body">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16 }}>{appSel.titolo}</div>
                <div style={{ fontSize: 13, color: 'var(--text)', marginTop: 8 }}>📅 {dataFmt}<br />🕐 {appSel.ora?.slice(0, 5)}</div>
                {appSel.note && <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 8, fontStyle: 'italic' }}>{appSel.note}</div>}
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 20, background: 'var(--surface2)', color: statoColor[appSel.stato] }}>{statoLabel[appSel.stato]}</div>
            </div>
            {appSel.min_partecipanti > 0 && (
              <div style={{ marginTop: 10, fontSize: 12, color: si.length >= appSel.min_partecipanti ? 'var(--green)' : 'var(--accent3)', background: si.length >= appSel.min_partecipanti ? 'rgba(74,222,128,0.1)' : 'rgba(255,120,87,0.08)', borderRadius: 8, padding: '6px 10px', border: `1px solid ${si.length >= appSel.min_partecipanti ? 'rgba(74,222,128,0.3)' : 'rgba(255,120,87,0.2)'}` }}>
                {si.length >= appSel.min_partecipanti ? '✅' : '⚠️'} Min. partecipanti: {si.length}/{appSel.min_partecipanti}
              </div>
            )}
          </div>
        </div>
        {appSel.stato === 'aperto' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <button className="btn btn-primary" onClick={() => cambiaStato(appSel, 'confermato')}>✅ Conferma</button>
            <button className="btn btn-danger" onClick={() => cambiaStato(appSel, 'annullato')}>❌ Annulla</button>
          </div>
        )}
        {appSel.stato !== 'aperto' && (
          <button className="btn btn-secondary" onClick={() => cambiaStato(appSel, 'aperto')}>🔄 Riapri</button>
        )}
        <div className="card">
          <div className="card-header"><div className="card-title">📊 Adesioni ({risposte.length})</div></div>
          <div className="card-body" style={{ paddingTop: 0 }}>
            {risposte.length === 0 ? (
              <div style={{ fontSize: 13, color: 'var(--muted)', textAlign: 'center', padding: '20px 0' }}>Nessuna risposta ancora</div>
            ) : (
              <>
                {si.length > 0 && <div style={{ marginBottom: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--green)', textTransform: 'uppercase', marginBottom: 6 }}>✅ Ci sono ({si.length})</div>
                  {si.map(r => <div key={r.id} style={{ fontSize: 13, padding: '6px 0', borderBottom: '1px solid var(--border)' }}>{r.profili?.nome} {r.profili?.cognome}</div>)}
                </div>}
                {no.length > 0 && <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--red)', textTransform: 'uppercase', marginBottom: 6 }}>❌ Non ci sono ({no.length})</div>
                  {no.map(r => <div key={r.id} style={{ fontSize: 13, padding: '6px 0', borderBottom: '1px solid var(--border)' }}>{r.profili?.nome} {r.profili?.cognome}</div>)}
                </div>}
              </>
            )}
          </div>
        </div>
        {confermaElimina ? (
          <div className="card slide-up" style={{ border: '1px solid rgba(248,113,113,0.3)' }}>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>Eliminare questo appuntamento?</div>
              <div style={{ fontSize: 13, color: 'var(--muted)' }}>Verranno eliminate anche tutte le risposte degli atleti.</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <button className="btn btn-secondary" onClick={() => setConfermaElimina(null)}>Annulla</button>
                <button className="btn btn-danger" onClick={() => elimina(confermaElimina)}>Elimina</button>
              </div>
            </div>
          </div>
        ) : (
          <button className="btn btn-ghost" style={{ color: 'var(--red)', fontSize: 13 }} onClick={() => setConfermaElimina(appSel.id)}>🗑️ Elimina appuntamento</button>
        )}
        {toast && <div className="toast">{toast}</div>}
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} className="fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 13, color: 'var(--muted)' }}>Appuntamenti per {gruppoNome}</div>
        <button className="btn btn-primary btn-sm" onClick={() => setMostraForm(true)}>+ Nuovo</button>
      </div>

      {mostraForm && (
        <div className="card slide-up">
          <div className="card-header">
            <div className="card-title">📣 Nuovo appuntamento</div>
            <button onClick={() => { setMostraForm(false); resetForm() }} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>✕</button>
          </div>
          <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Titolo *</label>
              <input className="form-input" type="text" value={titoloForm} onChange={e => setTitoloForm(e.target.value)} placeholder="Es. Allenamento CrossFit" />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="form-group">
                <label className="form-label">Data *</label>
                <input className="form-input" type="date" value={dataForm} min={oggi} onChange={e => setDataForm(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Ora *</label>
                <input className="form-input" type="time" value={oraForm} onChange={e => setOraForm(e.target.value)} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Min. partecipanti (opzionale)</label>
              <input className="form-input" type="number" min="0" value={minForm} onChange={e => setMinForm(e.target.value)} placeholder="Es. 3" />
            </div>
            <div className="form-group">
              <label className="form-label">Note (opzionale)</label>
              <input className="form-input" type="text" value={noteForm} onChange={e => setNoteForm(e.target.value)} placeholder="Es. Portare scarpe da ginnastica" />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <button className="btn btn-secondary" onClick={() => { setMostraForm(false); resetForm() }}>Annulla</button>
              <button className="btn btn-primary" onClick={crea} disabled={salvataggio}>{salvataggio ? 'Salvataggio...' : '📣 Crea e notifica'}</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 0, background: 'var(--surface2)', borderRadius: 10, padding: 3 }}>
        {[{ id: 'prossimi', label: '📅 Prossimi' }, { id: 'passati', label: '📂 Passati' }].map(v => (
          <button key={v.id} onClick={() => setVista(v.id)} style={{
            flex: 1, padding: '7px 0', borderRadius: 8, border: 'none', cursor: 'pointer',
            fontSize: 12, fontWeight: 700, fontFamily: 'Syne',
            background: vista === v.id ? 'var(--surface)' : 'transparent',
            color: vista === v.id ? 'var(--accent)' : 'var(--muted)',
            boxShadow: vista === v.id ? '0 1px 4px rgba(0,0,0,0.2)' : 'none',
          }}>{v.label}</button>
        ))}
      </div>

      {appFiltrati.length === 0 ? (
        <div className="card"><div className="card-body" style={{ textAlign: 'center', padding: '24px', fontSize: 13, color: 'var(--muted)' }}>
          {vista === 'prossimi' ? 'Nessun appuntamento programmato.' : 'Nessun appuntamento passato.'}
          {vista === 'prossimi' && <><br /><button className="btn btn-primary" style={{ marginTop: 12 }} onClick={() => setMostraForm(true)}>+ Crea il primo</button></>}
        </div></div>
      ) : appFiltrati.map(app => {
        const dataFmt = new Date(app.data + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' })
        return (
          <div key={app.id} className="card" style={{ cursor: 'pointer' }} onClick={async () => { setAppSel(app); await caricaRisposte(app.id) }}>
            <div className="card-header">
              <div style={{ flex: 1 }}>
                <div className="card-title">{app.titolo}</div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 3 }}>{dataFmt} · {app.ora?.slice(0, 5)}</div>
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 20, background: 'var(--surface2)', color: statoColor[app.stato], whiteSpace: 'nowrap' }}>
                {statoLabel[app.stato]}
              </div>
            </div>
          </div>
        )
      })}
      {toast && <div className="toast">{toast}</div>}
    </div>
  )
}
